// Mesajlaşma — okunmamış kuralı. BE chat.php::unreadSinceSql ile AYNI (29.09.2026).
// admin ↔ müşteri ve admin ↔ partner odalarında taraflar EKİPTİR: ekip arkadaşının mesajı
// okunmamış sayılmaz ve karşı tarafın o ana kadarki mesajlarını "cevaplanmış" yapar (bir admin
// müşteriye cevap verince diğer adminlerde oda okunmuş olur). Ekip içi (internal:) odalarda
// kişi bazlıdır: yalnız kendi mesajım sayılmaz.

export function isInternalChatRoom(roomId) {
  return String(roomId || "").startsWith("internal:");
}

// Canlı gelen mesajın bu kullanıcı için anlamı:
//   "self"  → kendi mesajım (başka sekmeden): sayaç ve ses yok
//   "team"  → ekip arkadaşım karşı tarafa yazdı: oda benim için de okunmuş sayılır, ses yok
//   "other" → karşı taraf (ya da ekip içi odada başkası): okunmamış + ses
export function classifyIncomingChatMessage(roomId, message, myUserId, myType) {
  const senderId = String(message?.sender_user_id ?? "").trim();
  if (myUserId && senderId && senderId === String(myUserId)) return "self";
  if (!isInternalChatRoom(roomId) && myType && message?.sender_type === myType) return "team";
  return "other";
}
